import entity from '../../../models/base/dashboards'

export default [
  {
    path: '/dashboards',
    meta: {
      entity,
      requiresPermissionTo: 'dashboards',
      crud: 'list'
    },
    component: () =>
      import(/* webpackChunkName: 'dashboards' */ '@/views/dynamic/DynamicIndex')
  },
  {
    path: '/dashboards/new',
    meta: {
      entity,
      requiresPermissionTo: 'dashboards',
      crud: 'form'
    },
    component: () =>
      import(/* webpackChunkName: 'dashboards' */ '@/views/dynamic/DynamicIndex')
  },
  {
    path: '/dashboards/:id',
    meta: {
      entity,
      requiresPermissionTo: 'dashboards',
      crud: 'form'
    },
    component: () =>
      import(/* webpackChunkName: 'dashboards' */ '@/views/dynamic/DynamicIndex')
  }
]
